// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_status_container__zuKul {
    align-items: center;
    display: flex;
    justify-content: center;
}

.styles_aprovado__FSlsw {
    background-color: green;
    border-radius: 50%;
    height: .7rem;
    margin-right: .3rem;
    width: .7rem;
}

.styles_analise__Yb6Hi {
    background-color: orange;
    border-radius: 50%;
    height: .7rem;
    margin-right: .3rem;
    width: .7rem;
}

.styles_reprovado__pctLT {
    background-color: red;
    border-radius: 50%;
    height: .7rem;
    margin-right: .3rem;
    width: .7rem;
}

.styles_revisando__H4fUY {
    background-color: rgb(255, 102, 0);
    border-radius: 50%;
    height: .7rem;
    margin-right: .3rem;
    width: .7rem;
}

.styles_btnContainer__qavlR {
    display: flex !important;
    justify-content: flex-start !important;
}

.styles_btnFechar__edCWj {
    color: #18316e !important;
    border: 2px solid #18316e !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Juridico/ModalFilhos/styles.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC","sourcesContent":[".status_container {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}\n\n.aprovado {\n    background-color: green;\n    border-radius: 50%;\n    height: .7rem;\n    margin-right: .3rem;\n    width: .7rem;\n}\n\n.analise {\n    background-color: orange;\n    border-radius: 50%;\n    height: .7rem;\n    margin-right: .3rem;\n    width: .7rem;\n}\n\n.reprovado {\n    background-color: red;\n    border-radius: 50%;\n    height: .7rem;\n    margin-right: .3rem;\n    width: .7rem;\n}\n\n.revisando {\n    background-color: rgb(255, 102, 0);\n    border-radius: 50%;\n    height: .7rem;\n    margin-right: .3rem;\n    width: .7rem;\n}\n\n.btnContainer {\n    display: flex !important;\n    justify-content: flex-start !important;\n}\n\n.btnFechar {\n    color: #18316e !important;\n    border: 2px solid #18316e !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status_container": `styles_status_container__zuKul`,
	"aprovado": `styles_aprovado__FSlsw`,
	"analise": `styles_analise__Yb6Hi`,
	"reprovado": `styles_reprovado__pctLT`,
	"revisando": `styles_revisando__H4fUY`,
	"btnContainer": `styles_btnContainer__qavlR`,
	"btnFechar": `styles_btnFechar__edCWj`
};
export default ___CSS_LOADER_EXPORT___;
